import React from "react";
import * as LucideIcons from "lucide-react";

// Type for the icon name
type IconName = keyof typeof LucideIcons;

interface RenderIconProps {
  iconName: string;
  random?: boolean;
  size?: number;
  className?: string;
}

export const RenderIcon: React.FC<RenderIconProps> = ({
  iconName,
  random,
  size = 32,
  className,
}) => {
  if (!iconName && !random) {
    return null;
  }

  if (random && !iconName) {
    const iconNames = Object.keys(LucideIcons) as IconName[];
    const randomIconName = iconNames[Math.floor(Math.random() * iconNames.length)];
    const IconComponent = LucideIcons[randomIconName];

    // @ts-expect-error: ts
    return <IconComponent size={size} className={className} />;
  } else if (iconName) {
    const IconComponent = LucideIcons[iconName as IconName];

    return IconComponent ? (
      // @ts-expect-error: ts
      <IconComponent size={size} className={className} />
    ) : null;
  }
};
